export { default as topBlockTemplate } from './top-block.dot';



// WEBPACK FOOTER //
// ./default-modules/ui/top-block/templates/index.ts